var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineAndInperson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4268_75777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03106 4.36294C4.70216 4.5827 4.31548 4.7 3.91992 4.7C3.38949 4.7 2.88078 4.48928 2.50571 4.11421C2.13064 3.73914 1.91992 3.23043 1.91992 2.7C1.91992 2.30444 2.03722 1.91776 2.25698 1.58886C2.47675 1.25996 2.7891 1.00361 3.15455 0.852239C3.52001 0.700864 3.92214 0.661257 4.3101 0.738427C4.69806 0.815598 5.05443 1.00608 5.33414 1.28578C5.61384 1.56549 5.80432 1.92186 5.88149 2.30982C5.95866 2.69778 5.91906 3.09991 5.76768 3.46536C5.61631 3.83082 5.35996 4.14317 5.03106 4.36294Z",
    fill: "#354354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83556 5.68775C6.41107 6.04191 6.8739 6.55255 7.16994 7.16H5.39994C4.94378 7.14756 4.49882 7.30235 4.14886 7.59521C3.7989 7.88807 3.5681 8.29879 3.49994 8.75H1.49994C1.3396 8.75086 1.18141 8.71316 1.0387 8.64006C0.895984 8.56696 0.772941 8.46062 0.679945 8.33C0.576502 8.18697 0.512761 8.01911 0.495198 7.84348C0.477634 7.66784 0.506873 7.49068 0.579945 7.33C0.855821 6.67576 1.32154 6.11928 1.91694 5.73245C2.51234 5.34562 3.21005 5.14622 3.91994 5.16C4.59563 5.15054 5.26005 5.33359 5.83556 5.68775Z",
    fill: "#354354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06992 8.06H5.39992C4.85868 8.06 4.41992 8.49876 4.41992 9.04V12.37C4.41992 12.9112 4.85868 13.35 5.39992 13.35H9.06992C9.61116 13.35 10.0499 12.9112 10.0499 12.37V9.04C10.0499 8.49876 9.61116 8.06 9.06992 8.06Z",
    fill: "#354354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 8.65C12.563 8.6381 12.6274 8.6381 12.6902 8.65C12.773 8.63262 12.8586 8.63326 12.9411 8.65186C13.0237 8.67046 13.1012 8.7066 13.1686 8.75781C13.2359 8.80903 13.2914 8.87413 13.3314 8.9487C13.3714 9.02327 13.3948 9.10557 13.4002 9.19V12.19C13.3999 12.2952 13.3723 12.3986 13.3202 12.49C13.281 12.5571 13.2289 12.6159 13.1668 12.6628C13.1048 12.7097 13.0342 12.7439 12.9589 12.7634C12.8836 12.783 12.8052 12.7874 12.7282 12.7765C12.6512 12.7656 12.5771 12.7396 12.5102 12.7L10.9702 11.82V9.53L12.5002 8.65Z",
    fill: "#354354"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4268_75777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineAndInperson);
export default __webpack_public_path__ + "static/media/onlineAndInperson.58b81e7b63753a77ece34c96f31b37c8.svg";
export { ForwardRef as ReactComponent };